import { getLogin } from "../components/Login";

export const Join = getLogin("signup");
export const Login = getLogin("login");
